import Locale from "locale";

export const getMaxErrorValidation = (max: number) =>
  [max, Locale.errors.max.replace("{}", max.toString())] as [number, string];
